let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fCic7")).then(() => parcelRequire('5F05h'));